module.exports = __webpack_public_path__ + "static/media/tiktok.c28071fc.png";